"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Random__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "initCaller",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "caller",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256",
            },
        ],
        name: "generateSignature",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newCaller",
                type: "address",
            },
        ],
        name: "setCaller",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class Random__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(initCaller, overrides) {
        return super.deploy(initCaller, overrides || {});
    }
    getDeployTransaction(initCaller, overrides) {
        return super.getDeployTransaction(initCaller, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Random__factory = Random__factory;
Random__factory.bytecode = _bytecode;
Random__factory.abi = _abi;
//# sourceMappingURL=Random__factory.js.map